//@ts-nocheck
import React, { useState } from 'react'
import { Toaster, toast } from 'sonner'
import { Dialog, DialogBackdrop, DialogPanel, DialogTitle } from '@headlessui/react'
import { CrossIcon, ExclamationIcon } from '../icons/Icons';
import { useParams } from 'react-router-dom';
import { useAppDispatch } from '../../app/hooks';
import { assignJobPipelineDetailsData, fetchJobPipelineDetailsData, fetchPipelineList } from '../../features/hiringpipeline/hiringPipelineSlice';
import { fetchBoardsList } from '../../features/teams/teamsSlice';

interface JobPipelineProps {
  // Define the properties of ChannelProps here
}


const HiringPipelineDetails: React.FC<JobPipelineProps> = React.memo(({ pipelineData, setPipelineData ,setPipelineDataDetails }) => {
  const [createPipelineModal, setCreatePipelineModal] = useState(false)
  const [createPipelineLoading, setCreatePipelineLoading] = useState(false)
  const [createPipelineAssignLoading, setCreatePipelineAssignLoading] = useState(false)
  const [jobPipeline, setJobPipeline] = useState<any[]>([]);
  const { baseId } = useParams<{ baseId: string }>();
  const { jobId } = useParams<{ jobId: string }>();
  const dispatch = useAppDispatch();
  const [searchTerm, setSearchTerm] = useState(''); // Add searchTerm state here
  const [selectedTemplate, setSelectedTemplate] = useState<any>(null);
  const [createPipelineAssignLoadingSave, setCreatePipelineAssignLoadingSave] = useState(false)



  const handleCreatePipline = async () => {
    if (!baseId || !jobId) {
      toast.error("Invalid Base ID or Job ID");
      return;
    }

    // Show modal immediately
    setCreatePipelineModal(true);

    // Set loading state to true
    setCreatePipelineLoading(true);

    try {
      // Fetch data
      const baseResponse = await dispatch(fetchBoardsList(baseId));

      if (baseResponse?.payload) {
        setJobPipeline(baseResponse.payload.data);
        // Optionally save to local storage
        // localStorage.setItem('baseScoreCardDataByJob', JSON.stringify(baseResponse.payload));
      } else {
        setJobPipeline([]);
      }
    } catch (error) {
      console.error("Error fetching teams:", error);
      setJobPipeline([]);
      toast.error("Failed to fetch pipeline details");
    } finally {
      // Reset loading state
      setCreatePipelineLoading(false);
    }
  };


  const filteredPipelines = jobPipeline.filter((pipeline: any) =>
    pipeline.name.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const onTemplateSelect = (template: any) => {
    setSelectedTemplate(template);
  };

  const handleAssignPipeline = async () => {
    if (!baseId || !jobId || !selectedTemplate?.id) {
      toast.error("Invalid Base ID, Job ID, or Pipeline Template");
      return;
    }

    setCreatePipelineAssignLoadingSave(true);

    try {
      const response = await dispatch(
        assignJobPipelineDetailsData({
          baseId: parseInt(baseId, 10),
          JobId: jobId,
          userId: selectedTemplate.id
        })
      );

      if (response.meta.requestStatus === 'fulfilled') {
        toast.success("Hiring assigned successfully!");
    

        const response = await dispatch(
          fetchJobPipelineDetailsData({
            baseId: Number(baseId),
            JobId: jobId
          })
        );
        
        if (response.meta.requestStatus === 'fulfilled') {          
          localStorage.setItem('jobByHiringTeamMembers', JSON.stringify(response.payload.data.teamMembers))          
          setPipelineData(response.payload.data.teamMembers);
          setPipelineDataDetails(response.payload.data);
        }
        setCreatePipelineModal(false); // Close the modal on success
        setSelectedTemplate('')
        // localStorage.setItem('baseTeamsData', JSON.stringify(baseResponseData.payload));

      } else {
        throw new Error(response.payload || "Failed to assign pipeline");
      }
    } catch (error: any) {
      toast.error(error.message || "Failed to assign pipeline");
    } finally {
      setCreatePipelineAssignLoadingSave(false);
    }
  };



  return (
    <>
      <Toaster richColors />
      <main className='py-[34px] lg:py-[70px] px-0 lg:px-10 h-full flex'>
        <div className='px-[2px] sm:px-6 lg:px-8 w-full flex justify-center'>
          <div className='w-full max-w-[640px]'>
            {/* <Link to={`/${baseId}/settings/pipeline`}
              className=' flex items-center gap-x-1 w-full mb-4'
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width={24}
                height={24}
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth={2}
                strokeLinecap="round"
                strokeLinejoin="round"
                className="icon icon-tabler icons-tabler-outline icon-tabler-chevron-left w-[0.9rem] h-[0.9rem]"
              >
                <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                <path d="M15 6l-6 6l6 6" />
              </svg>
              <span className='text-black-100 text-[13px]'>
                Back to pipeline
              </span>
            </Link> */}
            <div className='flex flex-col gap-y-[6px]'>
              <h2 className='text-[20px] lg:text-[24px] font-medium leading-8 text-[#1b1b1b] tracking-[-0.01rem] capitalize'>Hiring Pipeline</h2>
              <p className='text-sm leading-6 text-[#5c5c5e] font-medium capitalize'>Hiring description</p>
            </div>

            <div className='bg-[#e0e0e0] w-full h-[1px] my-6'></div>
            <span className='text-center block text-[13px] text-dark-black-200'>There is no hiring here </span>

            <div className=' mt-6 lg:mt-10 flex items-center justify-center w-full mb-5'>
              <button
                onClick={handleCreatePipline}
                className='group inline-flex shrink-0 select-none transition-colors duration-100 wg-antialiased focus:outline-0 focus-visible:outline
                          focus-visible:outline-2 focus-visible:outline-offset-2 disabled:pointer-events-none gap-0 items-center px-[14px] py-1 text-[13px] font-medium h-[32px] rounded-md text-white outline-primary disabled:opacity-50
                           bg-indigo-600 hover:bg-indigo-500 focus-visible:outline-indigo-600 
                         justify-start [&>span]:flex [&>span]:items-center [&>span]:gap-[6px]'>
                Create Hiring
              </button>
            </div>
          </div>
        </div>
      </main>


      <Dialog open={createPipelineModal} onClose={setCreatePipelineModal} className="relative z-10">
        <DialogBackdrop
          transition
          className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity data-[closed]:opacity-0 
          data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in"
        />

        <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
          <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
            <DialogPanel
              transition
              className="relative transform rounded-lg bg-white px-4 pb-4 pt-5 text-left shadow-xl transition-all
               data-[closed]:translate-y-4 data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in 
               sm:my-8 sm:w-full sm:max-w-[34rem] sm:p-4 data-[closed]:sm:translate-y-0 data-[closed]:sm:scale-95"
            >
              <div className="absolute right-0 top-0 hidden pr-4 pt-4 sm:block">
                <button
                  type="button"
                  onClick={() => setCreatePipelineModal(false)}
                  className="rounded-md bg-white text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
                >
                  <span className="sr-only">Close</span>
                  <CrossIcon />
                </button>
              </div>
              <div className="flex flex-col gay-y-4">

                <DialogTitle
                  as="h3"
                  className="text-base font-semibold leading-6 text-gray-900"
                >
                  Assign Hiring team
                </DialogTitle>
                <div className='border-b border-solid border-[#e3e3e3] mx-[-16px] px-[8px] block py-[8px]'></div>
                <div className="mt-6">
                  <div className="mt-0">

                    {/* <label className='wg-label inline-flex cursor-pointer items-center gap-1 text-sm font-medium leading-6 mt-1.5'>Template Name</label> */}
                    <input
                      type="text"
                      placeholder="Search Template"
                      value={searchTerm}
                      // onKeyDown={handleKeyPress}

                      onChange={(e) => setSearchTerm(e.target.value)}
                      className="px-3 py-[10px] w-[100%] border mt-0 border-gray-200 border-solid  rounded-t-lg text-sm border-b-0 focus:outline-none focus:ring-0 focus:ring-gray-200 focus:border-gray-200"

                    />
                  </div>
                  <div className="overflow-x-hidden">
                    <table className="min-w-full divide-y divide-x divide-gray-200">
                    <tbody className="bg-white divide-y rounded-b-lg block divide-gray-200 border border-solid border-[#e5e7eb] overflow-y-auto max-h-[400px] h-full">
                        {createPipelineLoading ? (
                          <tr className='flex items-center justify-center'>
                            <td colSpan={4} className="px-6 py-4 text-center">
                              <div className="flex items-center justify-center relative z-50">
                                <div className="simple-spinner-loader">
                                  <span></span>
                                </div>
                              </div>
                            </td>
                          </tr>
                        ) : filteredPipelines.length > 0 ? (
                          filteredPipelines.map((template: any, index: number) => {                            
                            return (
                              <tr
                                key={index}
                                onClick={() => onTemplateSelect(template)}
                                className={`flex items-center px-2 pt-[6px] pb-[7px] cursor-pointer w-full ${selectedTemplate?.id === template.id ? 'bg-indigo-50' : ''}`}
                              >

                                <div>
                                  {
                                    template?.name &&
                                    <div className='flex shrink-0 pr-0 mt-[0px]'>
                                      <span
                                        className="flex h-6 w-6 shrink-0 items-center justify-center rounded-full border-none text-[0.625rem] font-medium text-white capitalize bg-gray-400"
                                        style={{ backgroundColor: template?.color  }}
                                      >
                                        {template.name[0]}
                                      </span>
                                    </div>
                                  }
                                </div>

                                <div className='flex flex-col'>
                                <td className="px-4 pt-0 pb-[0px] text-[#1b1b1b] text-[13px] font-normal
                    whitespace-nowrap  overflow-hidden text-ellipsis w-[400px] capitalize">
                                    {template.name}
                                  </td>
                                  {
                                    template.description &&
                                    <td className="px-4 pt-0 pb-0 whitespace-nowrap  w-[400px]">
                                    <div className=' flex items-center max-w-fit '>
                                      <span className="flex items-center gap-[6px] 
text-[13px] text-[#5c5c5e]  rounded-md px-0 leading-4 capitalize
">

                                          {template.description}
                                        </span>
                                      </div>
                                    </td>
                                  }
                                </div>

                              </tr>
                            );
                          })
                        ) : (
                          <tr className='flex items-center justify-center'>
                            <td colSpan={4} className="px-6 py-4 text-center text-sm text-gray-500">
                              <div className='w-full mt-5 flex justify-center items-center flex-col gap-y-3'>
                                <ExclamationIcon />
                                <p className='text-[#0000007a] text-[13px]'>No results found</p>
                              </div>
                            </td>
                          </tr>
                        )}

                      </tbody>
                    </table>
                  </div>

                  <span className="border-b border-solid border-[#e3e3e3] mx-[-16px] px-[8px] block py-[6px]"></span>
                  <div className="flex items-center justify-end gap-[22px] pt-4 flex-wrap md:flex-nowrap lg:flex-nowrap">
                    <button
                      type="submit"
                      className="inline-flex items-center relative justify-center whitespace-nowrap rounded-md bg-indigo-600 font-medium leading-normal help-btn-setting text-[#fefeff] min-w-[32px] h-[32px] px-[14px] text-[0.8125rem]"
                      onClick={handleAssignPipeline}
                    >
                      <div className='flex items-center flex-row-reverse gap-[6px]'>

                        {createPipelineAssignLoadingSave ? (
                          <div className='flex items-center  gap-[6px]'>
                            Create
                            <div className="simple-spinner">
                              <span></span>
                            </div>
                          </div>
                        ) : (
                          'Create'
                        )}
                      </div>
                    </button>
                  </div>
                </div>

              </div>

            </DialogPanel>
          </div>
        </div>
      </Dialog>

    </>
  )

});

export default HiringPipelineDetails





